import { TranslationService } from "../../services/TranslationService";
import TabPosition from "../shared/TabPosition";
import CurrencyConfiguration from "./Configuration/CurrencyConfiguration";
import DashboardConfiguration from "./Configuration/DashboardPanelConfiguration";
import EmailTemplateConfiguration from "./Configuration/EmailTemplateConfiguration";
import OtherConfiguration from "./Configuration/OtherConfiguration";
import VerticalMenu from "../shared/components/VerticalMenu";
import TransactionType from "./Configuration/TransactionType";
import ActivityType from "./Configuration/ActivityType";
import InvoiceStatus from "./Configuration/InvoiceStatus";
import DataCompanyConfiguration from "./Configuration/DataCompanyConfiguration";
import TagsConfiguration from "./Configuration/TagsConfiguration";
import SMSConfiguration from "./Configuration/SMSConfiguration";
import { ConfigurationProvider } from "./ConfigurationContext";
import WhatsappTemplateConfiguration from "./Configuration/WhatsappTemplateConfiguration";
import CompanyService from "../../services/CompanyService";
import { ClientFieldConfiguration, InvoiceFieldConfiguration, PaymentFieldConfiguration } from "./Configuration/FieldConfiguration/Fields/EntityFieldConfiguration";
import ImportLog from "./Configuration/ImportLog";
import AssistantConfiguration from "./Configuration/AssistantConfiguration";
import ProcessLog from "./Configuration/ProcessLog";
import { addIf } from "../../utils/Utils";
import UserList from "../user/List";
import ImportTemplateConfiguration from "./Configuration/ImportTemplate/ImportTemplateConfiguration";
import { Helmet } from "react-helmet";

const CompanyConfiguration: React.FC = () => {
    const { translate } = TranslationService;

    let tabs = [
        { title: translate.Company, component: DataCompanyConfiguration },
        { title: translate.Users, component: UserList },
        { title: translate.Currencies, component: CurrencyConfiguration },
        {
            title: translate.Fields,
            hasItems: true,
            items: [
                { title: translate.Client, component: ClientFieldConfiguration, hash: "ClientFields" },
                { title: translate.Invoice, component: InvoiceFieldConfiguration, hash: "InvoiceFields" },
                { title: translate.Payment, component: PaymentFieldConfiguration, hash: "PaymentFields" },
            ]
        },
        {
            title: translate.Tipificaciones,
            hasItems: true,
            items: [
                { title: translate.EstadosFacturas, component: InvoiceStatus },
                { title: translate.ActivitiesTypes, component: ActivityType },
                { title: translate.EtiquetasGestion, component: TagsConfiguration },
                { title: translate.PaymentTypes, component: TransactionType }
            ]
        },
        {
            title: translate.Importaciones,
            hasItems: true,
            items: [
                { title: translate.Configuration, component: ImportTemplateConfiguration },
                { title: translate.ImportLog, component: ImportLog },
                { title: translate.EstatusProcesos, component: ProcessLog },
            ]
        },
        {
            title: translate.Templates,
            hasItems: true,
            items: [
                { title: translate.EmailTemplates, component: EmailTemplateConfiguration },
                ...addIf(CompanyService.canShowWhatsApp(), { title: translate.WhatsAppTemplates, component: WhatsappTemplateConfiguration }),
                { title: translate.SMSTemplates, component: SMSConfiguration },
            ]
        },
        { title: "Dashboard", component: DashboardConfiguration },
        {
            title: translate.OtherSettings, component: () =>
                <ConfigurationProvider>
                    <OtherConfiguration />
                </ConfigurationProvider>
        },
        ...addIf(CompanyService.getCompanyToken()?.inhouse === '1', {
            title: "Asistente IA", component: AssistantConfiguration
        })
    ];

    return (
        <TabPosition module="Configuration">
            <Helmet>
                <title>Intiza</title>
            </Helmet>
            <div className="main-layout-container">
                <div className="main-panel configuration">
                    <VerticalMenu items={tabs} title={TranslationService.translate.CompanySettings} />
                </div>
            </div>
        </TabPosition>
    );
};

export default CompanyConfiguration;